<template>
  <DialogTemplate>
    <div
      class="py-2 px-2 mb-4"
      style="max-width: 520px"
    >
      <div class="text-large weight_700 clr-primary">
        {{ $t('common.help') }}
      </div>
      <div
        v-for="item in options"
        :key="item.title"
        class="mt-4"
      >
        <div class="f-align-center pb-1 weight_700 mt-2">
          {{ item.title }}
        </div>
        <div class="clr-grey ml-4">
          <div
            class="mb-2"
            v-html="item.description"
          ></div>
          <div
            v-if="item.formula"
            class="mb-2"
            v-html="item.formula"
          ></div>
          <div
            v-if="item.note"
            class="text-italic text-small bl-grey_2s px-2s pr-6 my-2 clr-grey ml-8"
            v-html="item.note"
          />
          <div
            v-if="item.importance"
            class="mb-2"
            v-html="item.importance"
          ></div>
          <div
            v-if="item.details"
            class="text-italic text-small bl-grey_2s px-2s pr-6 my-2 clr-grey"
          >
            <div
              class="weight_600"
              v-html="item.details.title"
            ></div>
            <ul
              v-for="detail in item.details.items"
              :key="detail"
              class="f-column"
              style="gap: 0.25rem"
            >
              <li v-html="detail"></li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <template #dialog_actions>
      <v-btn
        class="ml-auto"
        @click="close"
      >
        {{ $t('btn.close') }}
      </v-btn>
    </template>
  </DialogTemplate>
</template>

<script>
import DialogTemplate from '@/components/Dialogs/DialogTemplate'
import links_mix from '@/mixins/links_mix'

export default {
  name: 'EvConverterHelpDialog',
  components: {
    DialogTemplate,
  },
  mixins: [links_mix],
  data() {
    return {}
  },
  methods: {
    close() {
      this.$store.dispatch('router_reset_dialogs')
    },
  },
  computed: {
    options() {
      return [
        {
          title: this.$t('solfigr.icm.ev_converter.CSTE.title'),
          description: this.$t('solfigr.icm.ev_converter.CSTE.description'),
          benefits: this.$t('solfigr.icm.ev_converter.CSTE.benefits'),
          formula: this.$t('solfigr.icm.ev_converter.CSTE.formula'),
          note: this.$t('solfigr.icm.ev_converter.CSTE.note'),
        },
        {
          title: this.$t('solfigr.icm.ev_converter.CSTE_Pot.title'),
          description: this.$t('solfigr.icm.ev_converter.CSTE_Pot.description'),
          formula: this.$t('solfigr.icm.ev_converter.CSTE_Pot.formula'),
          note: this.$t('solfigr.icm.ev_converter.CSTE_Pot.note'),
        },
        {
          title: this.$t('solfigr.icm.ev_converter.TEQ.title'),
          description: this.$t('solfigr.icm.ev_converter.TEQ.description'),
          formula: this.$t('solfigr.icm.ev_converter.TEQ.formula'),
          details: {
            title: this.$t('solfigr.icm.ev_converter.TEQ.details.title'),
            items: [
              this.$t('solfigr.icm.ev_converter.TEQ.details.items.custom_solution'),
              this.$t('solfigr.icm.ev_converter.TEQ.details.items.pre_solved_solution'),
              this.$t('solfigr.icm.ev_converter.TEQ.details.items.note'),
            ],
          },
        },
        {
          title: this.$t('solfigr.icm.ev_converter.Dollar_EV.title'),
          description: this.$i18n.g1
            ? this.$t('solfigr.icm.ev_converter.Dollar_EV.description')
            : this.$t('solfigr.icm.ev_converter.Dollar_EV.description_link', {
                url0: this.links_url_links.ev_converter_bounties.url,
                url1: this.links_url_links.ev_converter_icm.url,
                text0: this.links_url_links.ev_converter_bounties.text,
                text1: this.links_url_links.ev_converter_icm.text,
                cssClass: 'weight_500 text-underline_hover',
              }),
          importance: this.$t('solfigr.icm.ev_converter.Dollar_EV.importance'),
        },
      ]
    },
  },
}
</script>

<style lang="scss" scoped>
.rb-dialog_action {
  border-radius: 4px;
  text-shadow: var(--text-shadow_drop);
  min-width: 6rem;
}
</style>
